import { Heading } from '@repo/components/heading';

export function PageNotFound() {
  return (
    <div className="flex flex-col gap-4 mt-4">
      <Heading className="text-xl">404 Not Found</Heading>
      <p>Sorry, we were unable to find that page.</p>
    </div>
  );
}
